export interface AudioSourceDef {
    name: string;
    path: string;
    loop?: boolean;
    volume?: number;
    pool?: number;
}

const audioSources: AudioSourceDef[] = [
    { name: 'startup', path: 'audio/startup.mp3', volume: 0.6 },
    { name: 'office', path: 'audio/office.mp3', volume: 0.25, loop: true },
    {
        name: 'mouseDown',
        path: 'audio/mouse_down.mp3',
        volume: 0.5,
        pool: 4,
    },
    {
        name: 'mouseUp',
        path: 'audio/mouse_up.mp3',
        volume: 0.5,
        pool: 4,
    },
    { name: 'key1', path: 'audio/key_1.mp3', volume: 0.4, pool: 4 },
    { name: 'key2', path: 'audio/key_2.mp3', volume: 0.4, pool: 4 },
    { name: 'key3', path: 'audio/key_3.mp3', volume: 0.4, pool: 4 },
    { name: 'key4', path: 'audio/key_4.mp3', volume: 0.4, pool: 4 },
];

export default audioSources;
